import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from 'apps/t2c-fe/utils';

interface ImageMetadata {
  width: number;
  height: number;
  size: number;
}

interface VideoMetadata {
  width: number;
  height: number;
  size: number;
  duration: number;
}

interface AudioMetadata {
  size: number;
  duration: number;
}

interface UpdateMetadataParams {
  uploadId: string;
  metadata: ImageMetadata | VideoMetadata | AudioMetadata;
}

export const updateUploadData = async ({ uploadId, metadata }: UpdateMetadataParams) => {
  return axiosInstance.patch(`/api/uploads/${uploadId}`, { metadata }).then((res) => res.data);
};

export function useUpdateUploadData() {
  return useMutation(updateUploadData, {
    onSuccess: (data) => data,
  });
}
